import type { ReactNode } from 'react';
import { cx } from '../cx.js';

export interface PageHeadingProps {
  children: ReactNode;
  /** Riga sotto il titolo in body, ink-muted. */
  subtitle?: ReactNode;
  /** `display` solo per la pagina di accesso e le copertine. */
  size?: 'title-1' | 'display';
  className?: string;
}

/** Titolo di pagina in Fraunces: uno per schermata. */
export function PageHeading({ children, subtitle, size = 'title-1', className }: PageHeadingProps) {
  return (
    <div className={cx('flex flex-col gap-2', className)}>
      <h1 className={size === 'display' ? 't-display' : 't-title-1'}>{children}</h1>
      {subtitle && <p className="t-body text-ink-muted">{subtitle}</p>}
    </div>
  );
}
